export const filterInitiativesByGroup = (group, initiatives, value, initiative) => {
  let filteredByGroup = [];

  value.forEach((summary) => {
    if (group[summary]) {
      filteredByGroup = filteredByGroup.concat(
        initiatives.filter((init) =>
          group[summary].some((not) => init._id === not._id)
        )
      );
    }
  });

  if (filteredByGroup.length >= 0) {
    return filteredByGroup.some((filteredInit) => filteredInit._id === initiative._id);
  }
  return false;
};